<mat-card class="slidecontent">
    <div class="headcontent">
        <h3>Filter</h3>  
    </div>
    <div class="dialog_content">
  
  
        <mat-form-field >
            <mat-label>By Date</mat-label>
            <input matInput placeholder="" />
          </mat-form-field>

          <mat-form-field >
            <mat-label>By Contact</mat-label>
            <input matInput placeholder="" />
          </mat-form-field>
          <mat-form-field >
            <mat-label>By User</mat-label>
            <input matInput placeholder="" />
          </mat-form-field>
  
    </div>
  
  
    <div class="actionBtn">
  
      <button mat-flat-button class="calltoaction" type="submit" color="basic"> Clear </button>
  
  
      <button mat-flat-button class="calltoaction" type="submit" color="primary">Apply</button>
  
  
  
    </div>
  
  
  </mat-card>
  

